export {TemplateHelpers} from './ui/Templates/TemplateHelpers';
export {TemplateCache} from './ui/Templates/TemplateCache';
export {HtmlTemplate} from './ui/Templates/HtmlTemplate';
export {UnderscoreTemplate} from './ui/Templates/UnderscoreTemplate';



/** WEBPACK FOOTER **
 ** ./src/TemplatesModules.ts
 **/